import {
  IS_ACTIVE,
  IS_ACTIVE_RIGHT_SIDEBAR,
  MODAL_OPEN,
  LIST_CITIES,
  LIST_ADDRESS,
  CHANGE_SEARCH,
  NEW_ALERT_NAME,
  SET_MARKET_TYPE,
  UPDATE_MARKERS,
  UPDATE_INFO_WINDOWS,
  UPDATE_CLUSTERS,
  ADD_MARKER,
  ADD_PIN,
  REMOVE_PIN,
  REMOVE_CLUSTERS,
  REMOVE_MARKERS,
  SET_IS_LOADING_MAP,
  SET_DISPLAY_CHARTS,
  SET_DISPLAY_STUDIES_LIST,
  SET_DISPLAY_STUDY_CREATION_GUIDE,
} from './dashboardActions';

const initialCity = {
  BoundBox:
    '{"northeast":{"lat":-23.3566039,"lng":-46.3650844},"southwest":{"lat":-24.0082209,"lng":-46.825514}}',
  EstadoId: 26,
  Id: 5270,
  IsLitoranea: false,
  Nome: 'São Paulo',
  NomeASCI: 'SAO PAULO',
  NomeKey: 'ec4058844f75fecb0f6f5ccf928b2479',
  PontoCentralLatitude: -23.550421,
  PontoCentralLongitude: -46.633468,
  PropriedadesEEmovel: {
    AtuacaoPlataforma: true,
    Capital: true,
    IptuYear: 2020,
    MostraEmOndeAtuamos: true,
    Proprietarios: true,
    Zoneamento: false,
    Zoom: 12,
    coordinates: [-23.550421, -46.633468],
  },
  SiglaKey: '4dcd0470f0f01c4348efa475dba9f1ad',
  boundbox: [
    [-46.3650844, -23.3566039],
    [-46.825514, -24.0082209],
  ],
  uf: 'SP',
};

const initialState = {
  shapeInfos: {},
  newAlertName: '',
  statusModal: '',
  isActive: {
    sidebar: true,
    menuAction: '2',
    mapAction: '',
    results: false,
  },
  isActiveRightSidebar: {
    menuAction: '0',
  },
  search: {
    city: initialCity,
    address: '',
    isFetched: false,
  },
  citiesList: [],
  addressList: [],
  marketType: 'primary',
  markers: [],
  infoWindows: [],
  clusters: [],
  pin: '',
  isLoadingMap: false,
  displayCharts: null,
  displayStudyCreationGuide: false,
};

export default function dashboardReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case IS_ACTIVE:
      return {
        ...state,
        isActive: { ...state.isActive, [payload.name]: payload.value },
      };
    case IS_ACTIVE_RIGHT_SIDEBAR:
      return {
        ...state,
        isActiveRightSidebar: {
          ...state.isActiveRightSidebar,
          [payload.name]: payload.value,
        },
      };
    case MODAL_OPEN:
      return { ...state, statusModal: payload };
    case LIST_CITIES:
      return { ...state, citiesList: payload };
    case LIST_ADDRESS:
      return { ...state, addressList: payload };
    case CHANGE_SEARCH:
      return {
        ...state,
        search: { ...state.search, [payload.name]: payload.value },
      };
    case NEW_ALERT_NAME:
      return { ...state, newAlertName: payload };
    case SET_MARKET_TYPE:
      return { ...state, marketType: payload };
    case UPDATE_MARKERS:
      return { ...state, markers: payload };
    case UPDATE_INFO_WINDOWS:
      return { ...state, infoWindows: payload };
    case UPDATE_CLUSTERS:
      return { ...state, clusters: payload };
    case ADD_MARKER:
      return { ...state, markers: [...state.markers, payload] };
    case ADD_PIN:
      return { ...state, pin: payload };
    case REMOVE_PIN:
      if (state.pin) state.pin.setMap(null);
      return { ...state, pin: '' };
    case REMOVE_CLUSTERS:
      if (state.clusters.activeMap_ !== undefined) {
        state.clusters.clearMarkers();
      }
      return { ...state, cluster: [] };
    case REMOVE_MARKERS:
      state.markers?.forEach((el) => {
        el.setMap(null);
      });
      return { ...state, markers: [] };
    case SET_IS_LOADING_MAP:
      return { ...state, isLoadingMap: payload };
    case SET_DISPLAY_CHARTS:
      return { ...state, displayCharts: payload };
    case SET_DISPLAY_STUDY_CREATION_GUIDE: {
      return { ...state, displayStudyCreationGuide: payload };
    }
    default:
      return state;
  }
}
